import { render, staticRenderFns } from "./HeaderPage.vue?vue&type=template&id=d8587ce6&"
import script from "./HeaderPage.vue?vue&type=script&lang=js&"
export * from "./HeaderPage.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPage.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports